import React, { useEffect, useRef } from 'react'
import 'react-phone-input-2/lib/style.css'
import { Field, ErrorMessage } from 'formik'
import PhoneInput from 'react-phone-input-2'
import { getPhoneCountry, normalizePhoneNumber } from './phoneNumber'

const PhoneField = ({ className, values, editMode, name, setFieldValue }) => {
  const country = getPhoneCountry(values)
  const selectedCountry = useRef(country)
  const visibleValue = normalizePhoneNumber(values[name], selectedCountry.current || country)
  const needsCountry = Boolean(visibleValue && !visibleValue.startsWith('+') && !country && !selectedCountry.current)

  useEffect(() => {
    if (editMode && visibleValue !== String(values[name] ?? '').trim()) {
      setFieldValue(name, visibleValue, false)
    }
  }, [editMode, name, setFieldValue, values, visibleValue])

  return (
    <>
      <PhoneInput
        key={country || 'unknown'}
        country={country?.toLowerCase()}
        disableInitialCountryGuess={needsCountry}
        disableCountryGuess={needsCountry}
        enableLongNumbers={true}
        placeholder='Enter phone number'
        value={visibleValue}
        enableSearch={true}
        required={true}
        onChange={(value, countryData, event) => {
          if (needsCountry && event?.type === 'click' && countryData?.countryCode) {
            const normalized = normalizePhoneNumber(values[name], countryData.countryCode.toUpperCase())
            if (normalized.startsWith('+')) {
              selectedCountry.current = countryData.countryCode.toUpperCase()
              setFieldValue(name, normalized)
              return
            }
          }
          selectedCountry.current = countryData?.countryCode?.toUpperCase() || selectedCountry.current
          const hasCountryCode = countryData?.dialCode || event?.target?.value?.trim().startsWith('+')
          setFieldValue(name, value && hasCountryCode ? '+' + value : value)
        }}
        disabled={!editMode}
        className={className}
      />
      {needsCountry && <div>Select the country for this phone number or enter the full number with its + country code.</div>}
      <Field type='hidden' name={name} value={values[name]} required />
      <ErrorMessage name={name}>phone required</ErrorMessage>
    </>
  )
}

export default React.memo(PhoneField)
